import MusicTrack from "@/domain/entities/music/MusicTrack";
import { MusicTrack as MusicTrackSDK } from "@cs_teamwaydev/mailvista-sdk_react";

const musicTrackMapper = (track: MusicTrackSDK): MusicTrack =>
    new MusicTrack({
        title: track.title,
        url: track.url,
    });

export default musicTrackMapper;
